import { render, staticRenderFns } from "./IdentityFindAddForm.vue?vue&type=template&id=5f31c4c7&scoped=true"
import script from "./IdentityFindAddForm.vue?vue&type=script&lang=js"
export * from "./IdentityFindAddForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f31c4c7",
  null
  
)

export default component.exports